import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import { useDashboard } from '@/views/dashboard/dashboard.provider';
import { useDashboardChartUtils } from '@/views/dashboard/dashboard.charts.utils';
import helperNeedRateChart from './helper-need-rate-chart.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'helper-need-rate-chart-controller',
  setup(__props) {

const dashboardChartUtils = useDashboardChartUtils();

const helperNeedRateChartConfig = useDashboard().gridUtilization.helperNeedRateChart;
const options = computed(() => ({
  ...helperNeedRateChartConfig.value.options,
  toolbox: {
    feature: {
      myTool1: dashboardChartUtils.options.toolbox.feature.maximize({
        chartOptions: helperNeedRateChartConfig,
        chartId: helperNeedRateChartConfig.value.chartId,
        componentInstance: helperNeedRateChart,
      }),
    },
  },
}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(helperNeedRateChart, {
    "chart-options": {
      ..._unref(helperNeedRateChartConfig),
      options: _unref(options),
    }
  }, null, 8, ["chart-options"]))
}
}

})